import React, { useEffect, useState } from "react";
import "./BannerOverlay.css"; // Or include this in your global CSS

const BannerOverlay = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem("lappPromoBannerDismissed");
    if (!dismissed) {
      setShowBanner(true);
    }
  }, []);

  const handleClose = () => {
    setShowBanner(false);
    localStorage.setItem("lappPromoBannerDismissed", "true");
  };

  if (!showBanner) return null;

  return (
    <div className="banner-overlay">
      <div className="banner-content">
        <p className="text-lg font-bold mb-2 text-[#1B162B]">🎮 Discover LApp – A Fun World of Science & Experiments!</p>
        <p className="text-[#1B162B] mb-4">Explore interactive science games and exciting experiments designed for young minds.</p>
        <a
          href="https://lapp.learnwithone.co.in"
          target="_blank"
          rel="noopener noreferrer"
          className="visit-btn"
        >
          🌟 Visit LApp Now »
        </a>
        <button onClick={handleClose} className="close-btn">✕</button>
      </div>
    </div>
  );
};

export default BannerOverlay;
